/* ============================================================
   Beni Product Card grid controller — <beni-card-grid>
   Shared card interactions (quick view + add to cart) for the
   beni-product-card snippet when used OUTSIDE <beni-product-tabs>
   (e.g. the beni-collection grid). Mirrors the card behaviour in
   section-beni-product-tabs.js:
     - click a card (data-quick-view="true") → window.BeniQuickView.open(url)
     - click [data-ptabs-atc]:
         · atc-mode "direct"    → add the card's variant to cart
         · atc-mode "quickview" → open the quick view to pick a variant
   Wrap any grid of beni-product-card markup in <beni-card-grid> to enable.
   ============================================================ */
(function () {
  if (customElements.get('beni-card-grid')) return;

  customElements.define(
    'beni-card-grid',
    class extends HTMLElement {
      connectedCallback() {
        if (this._inited) return;
        this._inited = true;
        this.bindCards();
      }

      bindCards() {
        var self = this;

        this.addEventListener('click', function (evt) {
          var card = evt.target.closest('[data-ptabs-card]');
          if (!card || !self.contains(card)) return;

          var atc = evt.target.closest('[data-ptabs-atc]');
          if (atc) {
            evt.preventDefault();
            if (atc.hasAttribute('disabled')) return;
            self.handleCardAtc(card, atc);
            return;
          }

          // click elsewhere on the card → quick view (if enabled)
          if (card.getAttribute('data-quick-view') === 'true') {
            evt.preventDefault();
            self.openQuickView(card, card);
            return;
          }

          // 主产品卡片：整卡点击直达 PDP。真链接（标题 / 拉伸覆盖层）走自身默认行为，
          // 非链接区域（图片/价格/描述）由 JS 兜底跳转，确保整卡都可点。
          if (card.getAttribute('data-card-link') === 'true') {
            if (evt.target.closest('a')) return;
            var linkUrl = card.getAttribute('data-product-url');
            if (linkUrl) window.location = linkUrl;
          }
        });

        this.addEventListener('keydown', function (evt) {
          if (evt.key !== 'Enter' && evt.key !== ' ' && evt.key !== 'Spacebar') return;
          var card = evt.target.closest('[data-ptabs-card]');
          if (!card || card !== evt.target) return; // only when the card itself is focused
          if (card.getAttribute('data-quick-view') !== 'true') return;
          evt.preventDefault();
          self.openQuickView(card, card);
        });
      }

      handleCardAtc(card, button) {
        var mode = card.getAttribute('data-atc-mode');
        if (mode === 'direct') {
          var variantId = card.getAttribute('data-variant-id');
          if (variantId) this.addToCart(variantId, 1, button);
          return;
        }
        // has variants → open the quick view to choose options
        if (card.getAttribute('data-quick-view') === 'true') {
          this.openQuickView(card, button);
        } else {
          var url = card.getAttribute('data-product-url');
          if (url) window.location = url;
        }
      }

      openQuickView(card, trigger) {
        var url = card.getAttribute('data-product-url');
        if (!url) return;
        if (window.BeniQuickView && typeof window.BeniQuickView.open === 'function') {
          window.BeniQuickView.open(url, trigger || card);
        } else {
          window.location = url;
        }
      }

      /* -------------------- Add to cart (mirrors product-form.js) -------------------- */
      addToCart(variantId, quantity, button) {
        var self = this;
        var cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('beni-cart-popover');

        if (button) button.classList.add('is-loading');

        var config;
        if (typeof fetchConfig === 'function') {
          config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
        } else {
          config = { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
        }

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity || 1);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

        fetch(addUrl, config)
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) {
              self.notifyError(response.description || response.message);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, { source: 'beni-card-grid', productVariantId: variantId, errors: response.errors || response.description, message: response.message });
              }
              return;
            }
            if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'beni-card-grid', productVariantId: variantId, cartData: response });
            }

            if (typeof cart.renderContents === 'function') cart.renderContents(response);
            if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch(function (e) {
            console.error('[beni-card-grid] add to cart failed', e);
            self.notifyError();
          })
          .finally(function () {
            if (button) button.classList.remove('is-loading');
          });
      }

      notifyError(message) {
        var msg = message || (window.cartStrings && window.cartStrings.error) || 'There was an error adding this item to your cart.';
        try { console.warn('[beni-card-grid]', msg); } catch (e) {}
        window.alert(msg);
      }
    }
  );
})();
